import * as Comp from "../../common/CommonComponents";
import * as common from "../../common/common";
import CssClass from "../../Styles/common.module.css";
import http from "../../common/http-common";
import UserListTable from "../../components/AccessManagement/Users/UserListTable";
import RegisterUsers from "../../components/AccessManagement/Users/RegisterUsers";
import { GetPagePermissionFn } from "../../common/authority";
import search from "../../assets/search-icon.png";
import register from "../../assets/register-icon.png";
import exportIcon from "../../assets/export-icon.png";

import { useEffect, useState } from "react";
// import Select, { components } from "react-select";
import { components } from "react-select";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";

const PAGE_NAME = "Users.js_";
const MODULE_ID = "WEB_USR_001";

const Users = (props) => {
  document.title = common.c_TITLE + " - User Maintenance";

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [dataToBeSelect, setDataToBeSelect] = useState({
    Organization: [],
  });

  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);

  const [showAdd, setShowAdd] = useState(false);

  const [roleTypeData, setRoleTypeData] = useState([]);
  const [roleType, setRoleType] = useState([]);
  const [orgData, setOrgData] = useState([]);
  const [org, setOrg] = useState([]);
  const [searchData, setSearchData] = useState([]);

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Users";
        onLoadingHandler(true, "Getting Users, please wait...");

        setAllData([]);

        const listItems = [];
        const roletypeSelected =
          roleType !== undefined && Object.keys(roleType).length !== 0
            ? roleType.map((r) => r.key)
            : "";
        // const userIdSelected =
        //   searchData.SEARCH_USER_ID === undefined
        //     ? ""
        //     : searchData.SEARCH_USER_ID.trim();
        const usernameSelected =
          searchData.SEARCH_USER_NAME === undefined
            ? ""
            : searchData.SEARCH_USER_NAME.trim();
        const orgSelected =
          org !== undefined && Object.keys(org).length !== 0
          ? org.map((r) => r.key)
          : "";
          

        http
          // .get(
          //   "api/users/GetAllUsers?_userID=" +
          //     userIdSelected +
          //     "&_role=" +
          //     roletypeSelected +
          //     "&_user=" +
          //     userId,
          //   { timeout: 10000000 }
          // )
          .get(
            "api/users/GetAllUsers?_username=" +
              usernameSelected +
              "&_role=" +
              roletypeSelected +
              "&_user=" +
              userId +
              "&_org=" +
              orgSelected,
            { timeout: 10000000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                listItems.push({
                  key: data.USER_ID,
                  USER_ID: data.USER_ID,
                  USER_FULL_NAME: data.USER_FULL_NAME,
                  USER_SHORT_NAME: data.USER_SHORT_NAME,
                  EMAIL: data.EMAIL,
                  ORG_ID: data.ORG_ID,
                  ORG_NAME: data.ORG_NAME,
                  USER_ROLE_ID: data.USER_ROLE_ID,
                  USER_CATEGORY: data.USER_CATEGORY,
                  ROLE_ID: data.ROLE_ID,
                  ROLE_NAME: data.ROLE_NAME,
                  LAST_ACCESS_DATETIME: data.LAST_ACCESS_DATETIME,
                  // STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                  ACTIVE_STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                  LOCK_STATUS: data.ACCOUNT_LOCK_FLAG === "Y" ? "Locked" : "Not Locked",
                  UPDATE_ID: data.UPDATE_ID,
                  UPDATE_NAME: data.UPDATE_NAME,
                  UPDATE_DATETIME: data.UPDATE_DATETIME,
                });
              });
            }
            setAllData(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting user list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting user list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";
      try {
        functionName = "useEffect Get Role List";
        onLoadingHandler(true, "Getting User Role List, please wait...");

        http
          .get("api/users/GetRoleList?_user=" + userId, { timeout: 10000 })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].ROLE_ID,
                value: response.data[i].ROLE_ID,
                label: response.data[i].ROLE_NAME,
              });
            }
            setRoleTypeData(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting user role list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting user role list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "Get Organization List";
        onLoadingHandler(true, "Getting Organization List, please wait...");
        http
          .get("api/users/GetOrgList?_user=" + userId)
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].ORG_ID,
                value: response.data[i].ORG_ID,
                label: response.data[i].ORG_NAME,
              });
            }
            setOrgData(listItems);
            setDataToBeSelect((prevState) => ({
              ...prevState,
              Organization: [...listItems],
            }));
          })
          .catch((err) => {
            toast.error("Error on getting organization list. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
          });
      } catch (err) {
        toast.error("Error on getting organization list. Please try again.");
        common.c_LogWebError(props.page, functionName, err);
      }
    } 
  }, [reload, actionAuthority, userId]);

  //#region Export Excel
  const onExcelHandler = () => {
    const roletypeSelected =
      roleType !== undefined && Object.keys(roleType).length !== 0
        ? roleType.map((r) => r.key)
        : "";
    // const userIdSelected =
    //   searchData.SEARCH_USER_ID === undefined
    //     ? ""
    //     : searchData.SEARCH_USER_ID.trim();
    const usernameSelected =
      searchData.SEARCH_USER_NAME === undefined
        ? ""
        : searchData.SEARCH_USER_NAME.trim();
    const orgSelected =
      org !== undefined && Object.keys(org).length !== 0
        ? org.map((r) => r.key)
        : "";

    window.open(
      // common.c_getApiUrl() +
      //   "api/users/ExportExcel?_userId=" +
      //   userIdSelected +
      //   "&_role=" +
      //   roletypeSelected +
      //   "&_user=" +
      //   userId
      common.c_getApiUrl() +
        "api/users/ExportExcel?_username=" +
        usernameSelected +
        "&_role=" +
        roletypeSelected +
        "&_user=" +
        userId +
        "&_org=" +
        orgSelected
    );
  };
  //#endregion

  //#region Event Handlers
  const showHideRegisterModal = () => {
    setShowAdd(!showAdd);
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;

      setSearchData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };
  //#endregion

  const ValueContainer = ({ children, ...props }) => {
    let [values, input] = children;

    if (Array.isArray(values)) {
      const plural = values.length === 1 ? "" : "s";
      values = `${values.length} item${plural} selected`;
    }

    return (
      <components.ValueContainer {...props}>
        {values}
        {input}
      </components.ValueContainer>
    );
  };

  return (
    <>
      <Comp.Header>User Maintenance</Comp.Header>

      <Comp.SearchPanel onSubmit={onReloadHandler}>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>User Role</td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.Select
              options={roleTypeData}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              // components={{ ValueContainer }}
              value={roleType}
              onChange={setRoleType}
              // placeholder="User Role"
              isMulti
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Username</td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.Input
              id="SEARCH_USER_NAME"
              type="text"
              className="form-control"
              isSearch={true}
              value={searchData.SEARCH_USER_NAME}
              onChange={inputUnrequiredHandler}
              // placeholder="Username"
            />
          </td>
        </tr>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Organization</td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.Select
              options={orgData}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              value={org}
              onChange={setOrg}
              isMulti
            />
          </td>
        </tr>
      </Comp.SearchPanel>
      <div className={CssClass.btnWrapper}>
        <Comp.Button id="btnSearch" type="general" onClick={onReloadHandler}>
          SEARCH  <img src={search} alt="Search" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button>
        {actionAuthority.WRITE === "Y" && (
          <Comp.Button
            id="btnRegister"
            type="general"
            onClick={showHideRegisterModal}
          >
            REGISTER  <img src={register} alt="Register" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
          </Comp.Button>
        )}
        {/* <Comp.Button
            id="btnRegister"
            type="general"
            onClick={showHideRegisterModal}
          >
            REGISTER
          </Comp.Button>      */}
        <Comp.Button id="btnExcel" type="excel" onClick={onExcelHandler}>
          EXPORT  <img src={exportIcon} alt="Export" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button>
      </div>
      <div className={`${CssClass.card} ${CssClass.tableCard}`}>
        {/* <h3 className={CssClass.tableTitle}>List of User</h3> */}
        {/* <hr /> */}
        <div style={{ width: "100%" }}>
          <UserListTable
            page={PAGE_NAME}
            module={MODULE_ID}
            dataToBeSelect={dataToBeSelect}
            data={allData}
            onReload={onReloadHandler}
            onLoading={onLoadingHandler}
            actionAuthority={actionAuthority}
          />
        </div>
      </div>
      <RegisterUsers
        page={PAGE_NAME}
        dataToBeSelect={dataToBeSelect}
        showHide={showAdd}
        onHide={showHideRegisterModal}
        onReload={onReloadHandler}
        module={MODULE_ID}
        onLoading={onLoadingHandler}
        autoComplete="off"
      />
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default Users;
